import { render, staticRenderFns } from "./BtnReprovarPertinencia.vue?vue&type=template&id=49c124d0"
import script from "./BtnReprovarPertinencia.vue?vue&type=script&lang=js"
export * from "./BtnReprovarPertinencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports